export default "<div class=\"footer\">\n  &copy; Orthogenic Technologies, Inc. All rights reserved.\n</div>\n"